import React from 'react'
import PropTypes from 'prop-types'
import { Button, Modal } from 'semantic-ui-react'

const AuthenticationFailedWarning = () => (
  <div className="ui negative message">
    <div className="content">
      <div className="header">Authentication Unsuccessful</div>
      <p>Please double check your credentials and try again.</p>
    </div>
  </div>
)

const AgentAuthenticationModal = ({
  token,
  email,
  subdomain,
  onChangeToken,
  onChangeEmail,
  onChangeSubdomain,
  onSubmit,
  isFailedAuthenticated,
  modalOpen,
  handleClose,
  handleOpen,
  isLoading,
}) => (
  <Modal
    size="small"
    open={modalOpen}
    onClose={handleClose}
    trigger={
      <button className="ui primary button" onClick={handleOpen}>
        Activate integration
      </button>
    }
  >
    <Modal.Header>Authenticate with Zendesk</Modal.Header>
    <Modal.Content>
      <p>
        To generate an API token, log in to your Zendesk account, navigate to <strong>Admin</strong>{' '}
        &gt; <strong>API</strong>, then follow the instructions on the page.
      </p>
      <form className="ui form">
        {isFailedAuthenticated ? <AuthenticationFailedWarning /> : null}
        <div className="field">
          <label>
            API Token{' '}
            <small>
              (
              <a
                href="https://help.simplesat.io/en/articles/7154584-zendesk-integrations#h_d2cd8028d7"
                target="_blank"
                rel="noreferrer"
              >
                how to get this
              </a>
              )
            </small>
          </label>
          <input
            type="text"
            name="api-token"
            placeholder="ex: A7sPSbwvqMMCDyRyeT7A5MwDNvk02PafBe7HfFBT"
            value={token}
            onChange={onChangeToken}
          />
        </div>
        <div className="two fields">
          <div className="field">
            <label>Zendesk subdomain</label>
            <div className="ui right labeled input">
              <input
                type="text"
                placeholder="subdomain"
                value={subdomain}
                onChange={onChangeSubdomain}
              />
              <div className="ui label">.zendesk.com</div>
            </div>
          </div>
          <div className="field">
            <label>Zendesk admin email address</label>
            <input
              type="text"
              name="zendesk-email-address"
              placeholder="The email address you use to log in"
              value={email}
              onChange={onChangeEmail}
            />
          </div>
        </div>
      </form>
    </Modal.Content>
    <Modal.Actions>
      <button className="ui deny button" onClick={handleClose}>
        Cancel
      </button>
      <Button primary loading={isLoading} onClick={onSubmit}>
        Authenticate
      </Button>
    </Modal.Actions>
  </Modal>
)

AgentAuthenticationModal.propTypes = {
  token: PropTypes.string,
  email: PropTypes.string,
  subdomain: PropTypes.string,
  onChangeToken: PropTypes.func.isRequired,
  onChangeEmail: PropTypes.func.isRequired,
  onChangeSubdomain: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isFailedAuthenticated: PropTypes.bool.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleOpen: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
}

export default AgentAuthenticationModal



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Admin/Surveys/ZendeskIntegrationSettings/AgentAuthenticationModal.js